import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import icons from "../../../assets/images/sprite-other-icons.svg";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { endpoints } from "../../../api/ApiEndPoints";
import { setbottomMenuContent } from "./cl_bottomMenu";

const BottomMenu = () => {
  const [activeItem, setActiveItem] = useState(null);

  const defaultList = [
    {
      labelName: "Home",
      path: "/",
      icons: "icon-home",
    },
    {
      labelName: "Loyalty",
      path: "/loyalty",
      icons: "icon-loyalty",
    },
    {
      labelName: "Coins",
      path: "/fasfascoins",
      icons: "icon-coins",
    },
    {
      labelName: "Profile",
      path: "/profile",
      icons: "icon-user-avatar",
    },
    {
      labelName: "Chat",
      path: "#",
      icons: "icon-chat",
    },
  ];
  function initFreshChat() {
    if (typeof window.fcWidget !== "undefined") {
      window.fcWidget.init({
        token: "OMIymK3pvcEm9ly1YGI5QmIw3qhzXFfBMjEcqpqDdhY=",
        host: "https://uae.fw-cdn.com",
      });
    } else {
      console.error("Freshchat widget not loaded.");
    }
  }

  function initialize(i, t) {
    var e;
    if (i.getElementById(t)) {
      initFreshChat();
    } else {
      e = i.createElement("script");
      e.id = t;
      e.async = true;
      e.src = "//uae.fw-cdn.com/40192381/119724.js";
      e.setAttribute('chat', 'true');
      e.onload = initFreshChat;
      i.head.appendChild(e);
    }
  }

  function initiateFreshchat() {
    initialize(document, "Freshchat-js-sdk");
  }

  // const handleChatClick = () => {
  //   initiateFreshchat();
  //   if (window.fcWidget) {
  //     window.fcWidget.open();
  //   }
  // };

  // useEffect(() => {
  //   initiateFreshchat();
  // }, []);

  const navigate = useNavigate();
  const menuRef = useRef(null);
  const menuBorderRef = useRef(null);
  const location = useLocation();
  const dispatch = useDispatch();
  const brandid = endpoints?.fasFasBrandId || 307;
  const { staticContent } = useSelector((state) => state?.bottomMenu);

  useEffect(() => {
    if (brandid) dispatch(setbottomMenuContent(brandid));
  }, [dispatch, brandid]);

  const list = Array.isArray(staticContent)
    ? staticContent.map(({ menu_name, menu_link, icontags, is_active }) => ({
      labelName: menu_name,
      path: menu_link,
      icons: icontags,
      is_active: is_active,
    }))
    : [];

  const handleClick = (index) => {
    setActiveItem(index);
    offsetMenuBorder();
    // if (list[index].labelName === "Chat") {
    //   handleChatClick();
    // }
  };

  const offsetMenuBorder = () => {
    const menu = menuRef.current;
    const menuBorder = menuBorderRef.current;
    const menuItems = menu.querySelectorAll(".menu__item");
    const activeItem = menu.querySelector(".active");

    if (activeItem && menuBorder) {
      const offsetActiveItem = activeItem.getBoundingClientRect();
      const left =
        Math.floor(
          offsetActiveItem.left -
          menu.offsetLeft -
          (menuBorder.offsetWidth - offsetActiveItem.width) / 2
        ) + "px";
      menuBorder.style.transform = `translate3d(${left}, 0 , 0)`;
    }
  };

  useEffect(() => {
    const path = location.pathname;
    const index = list?.findIndex((item) => item.path === path);
    setActiveItem(index !== -1 ? index : null);
  }, [location.pathname, list]);

  useEffect(() => {
    const menu = menuRef.current;
    const menuBorder = menuBorderRef.current;
    const menuItems = menu.querySelectorAll(".menu__item");

    function clickItem(item, index) {
      if (activeItem === index) return;
      if (activeItem !== null) {
        menuItems[activeItem]?.classList?.remove("active");
      }
      item.classList.add("active");
      setActiveItem(index);
      offsetMenuBorder(item, menuBorder);
    }

    function offsetMenuBorder(element, menuBorder) {
      if (!element || !element.getBoundingClientRect) return;

      const offsetActiveItem = element.getBoundingClientRect();
      const left =
        Math.floor(
          offsetActiveItem.left -
          menu.offsetLeft -
          (menuBorder.offsetWidth - offsetActiveItem.width) / 2
        ) + "px";
      menuBorder.style.transform = `translate3d(${left}, 0 , 0)`;
    }
    if (activeItem === null) {
      menuBorderRef.current.classList.remove("menu__border");
    } else {
      offsetMenuBorder(menuItems[activeItem], menuBorder);
      menuBorderRef.current.classList.add("menu__border");
    }
    offsetMenuBorder(menuItems[activeItem], menuBorder);

    menuItems.forEach((item, index) => {
      item.addEventListener("click", () => clickItem(item, index));
    });

    window.addEventListener("resize", () => {
      offsetMenuBorder(menuItems[activeItem], menuBorder);
    });

    return () => {
      window.removeEventListener("resize", () => {
        offsetMenuBorder(menuItems[activeItem], menuBorder);
      });
      menuItems.forEach((item, index) => {
        item.removeEventListener("click", () => clickItem(item, index));
      });
    };
  }, [activeItem]);

  return (
    <div id="page-mobile-footer">
      <div className="SB-mobile-footer" ref={menuRef}>
        <ul>
          {list?.length
            ? list?.map((item, index) => {
              if (item.labelName === "Chat") {
                return (
                  <li
                    className={`menu__item ${activeItem === index ? "active" : ""
                      }`}
                    key={index}
                    // onClick={() => {
                    //   handleClick(index);
                    // }}
                  >
                    <a
                      href="https://api.whatsapp.com/send/?phone=254705065203&text&type=phone_number&app_absent=0&wame_ctl=1"
                      // target="_blank"
                      rel="noopener noreferrer"
                      className="SB-mobile-footer-item"
                    >
                      <div className="SB-iconSVG">
                        <svg xmlns="http://www.w3.org/2000/svg">
                          <use xlinkHref={`${icons}#${item.icons}`} />
                        </svg>
                      </div>
                      <label>{item?.labelName}</label>
                    </a>
                  </li>
                );
              }
              return (
                <li
                  className={`menu__item ${activeItem === index ? "active" : ""
                    }`}
                  key={index}
                  onClick={() => {
                    handleClick(index);
                    navigate(`${item.path}`);
                  }}
                >
                  {item?.is_active && (
                    <Link className="SB-mobile-footer-item">
                      <div className="SB-iconSVG">
                        <svg xmlns="http://www.w3.org/2000/svg">
                          <use xlinkHref={`${icons}#${item.icons}`} />
                        </svg>
                      </div>
                      <label>{item?.labelName}</label>
                    </Link>
                  )}
                </li>
              );
            })
            : null}
        </ul>
        <div className="menu__border" ref={menuBorderRef}></div>
      </div>
    </div>
  );
};

export default BottomMenu;
